import React, {useState} from "react";
import {Typography} from "@material-ui/core";
import TableContainer from "@material-ui/core/TableContainer";
import Paper from "@material-ui/core/Paper";
import Table from "@material-ui/core/Table";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import TableCell from "@material-ui/core/TableCell";
import TableBody from "@material-ui/core/TableBody";

const ProductsSwapSummary = ({oldProduct, newProduct, customerEmail, onSubmitCallback, onBack}) => {

    const [updating, setUpdating] = useState(false);

    const confirmSwap = async (event) => {
        event.preventDefault();
        setUpdating(true);
        await onSubmitCallback();

    };

    return (
        <React.Fragment>
            <Typography variant="h6" gutterBottom>
                Old Product
            </Typography>
            <TableContainer component={Paper}>
                <Table size="small">
                    <TableHead>
                        <TableRow>
                            <TableCell>ID #</TableCell>
                            <TableCell>Name</TableCell>
                            <TableCell>Description</TableCell>
                            <TableCell>Price</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                            <TableRow key={oldProduct?.id}>
                                <TableCell component="th" scope="row">
                                    {oldProduct?.id}
                                </TableCell>
                                <TableCell>{oldProduct?.name}</TableCell>
                                <TableCell>{oldProduct?.description}</TableCell>
                                <TableCell>{oldProduct?.price}</TableCell>
                            </TableRow>
                    </TableBody>
                </Table>
            </TableContainer>

            <div className="mt-25">
                <Typography variant="h6" gutterBottom>
                    New Product
                </Typography>
                <TableContainer component={Paper}>
                    <Table size="small">
                        <TableHead>
                            <TableRow>
                                <TableCell>ID #</TableCell>
                                <TableCell>Name</TableCell>
                                <TableCell>Description</TableCell>
                                <TableCell>Price</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            <TableRow key={newProduct?.id}>
                                <TableCell component="th" scope="row">
                                    {newProduct?.id}
                                </TableCell>
                                <TableCell>{newProduct?.name}</TableCell>
                                <TableCell>{newProduct?.description}</TableCell>
                                <TableCell>{newProduct?.price}</TableCell>
                            </TableRow>
                        </TableBody>
                    </Table>
                </TableContainer>
            </div>
            <div className="mt-50">
                <button className="button save-btn accent mr-1"
                        onClick={ onBack }>
                    Back
                </button>
                <button className="button save-btn accent"
                        disabled={updating}
                        onClick={ confirmSwap }>
                    Confirm Swap
                </button>
            </div>
        </React.Fragment>
    )
};

export default ProductsSwapSummary;